<template>
  <a-modal width="600px" centered v-model:open="isOpen">
    <template #title>
        <div class="flex flex-col">
        <span class="text-lg font-bold primary-txt">{{ $t("Pos.ProductSelection") }}</span>
        <span class="text-gray-500 text-sm mb-3 primary-txt">{{ $t("Pos.SelectOneProduct") }}</span>
    </div>
    </template>
    
    <div class="product-list overflow-y-auto max-h-72">
      <div
        v-for="(item, index) in saleDetails"
        :key="item.id ?? index"
        :class="[
          'product-row flex items-center justify-between rounded-lg mb-2 px-3 py-2 cursor-pointer transition border-2',
          selectedItem === item
            ? 'border-primary bg-primary/10'
            : 'border-transparent bg-gray-50 hover:bg-gray-100',
        ]"
        :style="
          selectedItem === item && posConfig?.store?.primaryColor
            ? {
                borderColor: posConfig.store.primaryColor,
                backgroundColor: posConfig.store.primaryColor + '20',
              }
            : {}
        "
        @click="selectedItem = item"
      >
        <div class="flex items-center ">
            <div class="text-base font-semibold primary-txt">
              {{ item.product?.name ?? "-" }}
            </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-end gap-2">
        <a-button size="large" @click="close" class="primary-txt">
          {{ $t("Pos.Cancel") }}
        </a-button>
        <a-button
          class="primary-txt primary-btn"
          size="large"
          type="primary"
          :disabled="!selectedItem"
          :style="
            posConfig?.store?.primaryColor
              ? {
                  backgroundColor: posConfig.store.primaryColor,
                  borderColor: posConfig.store.primaryColor,
                }
              : {}
          "
          @click="confirm"
        >
          {{ $t("Pos.Confirm") }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LbrxProductSelectionModal",
});
</script>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from "vue";

export interface SaleDetailItem {
  id?: number;
  product: { id: number; name: string; full_price?: number; photo?: string };
  quantity: number;
  discount_quantity?: number;
  total?: number;
}

const props = defineProps<{
  open: boolean;
  saleDetails: SaleDetailItem[];
  posConfig?: { store?: { primaryColor?: string } };
}>();

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
  (e: "select", item: SaleDetailItem): void;
}>();

const isOpen = ref(props.open);
const selectedItem = ref<SaleDetailItem | null>(null);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
    if (newValue) selectedItem.value = null;
  }
);
watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

function close() {
  isOpen.value = false;
}

function confirm() {
  if (selectedItem.value) {
    emit("select", selectedItem.value);
    isOpen.value = false;
  }
}
</script>

<style scoped>
.primary-txt {
  font-family: "Exo 2", sans-serif;
}

.primary-btn:disabled {
  opacity: 0.5 !important;
}
</style>